import { render, staticRenderFns } from "./PosFormat.vue?vue&type=template&id=5ae1a493"
import script from "./PosFormat.vue?vue&type=script&lang=js"
export * from "./PosFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports